import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { T2LoadingService } from './t2-loading.service';
import { EventEmitter } from '@angular/forms/src/facade/async';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-t2-loading',
  templateUrl: './t2-loading.component.html',
  styleUrls: ['./t2-loading.component.scss']
})
export class T2LoadingComponent implements OnInit, OnDestroy {

  @Output() EmitterAction: EventEmitter<any> = new EventEmitter<any>();
  @Input() size: string;
  @ViewChild('appT2Loading') loading: ElementRef;
  subscriptions: Subscription[] = [];

  private view: boolean;
  private alive = true;
  protected proccess: string;

  constructor(private _service: T2LoadingService,
              private cdRef : ChangeDetectorRef) {}


  ngOnInit() {
    this.subscriptions.push(
      this._service.name$
        .takeWhile(() => this.alive)
        .subscribe((current) => {
          this.view = current > 0;
          this.cdRef.detectChanges();
          return this.EmitterAction.emit({
            isActive: this.view,
            current: current,
          });
        })
    );
    this.subscriptions.push(
      this._service.proccess$
        .takeWhile(() => this.alive)
        .subscribe((proc) => {
          this.proccess = proc;
        })
    );
  }

  ngOnDestroy() {
    this.cdRef.detach();
    this.subscriptions.map((subscribe: Subscription) => subscribe.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-loading/t2-loading.component.ts